import script from "./Header.vue?vue&type=script&setup=true&lang=ts"
export * from "./Header.vue?vue&type=script&setup=true&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=4632629c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4632629c"]])

export default __exports__